import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { ToggleButtonWithPopover } from '../../../components/common';
import { Layout } from '../../../constants/Layout';
import { LayoutChangeClickOrigin, useTrackLayoutChange } from '../../../utils/hooks/bi/useTrackLayoutChange';
import { memoizedOver } from '../../../utils/memoize';
import { IOuter } from './LayoutSwitcher.types';
import { LayoutSwitcherIcons } from './LayoutSwitcherIcons';
import { LayoutSwitcherMenu } from './LayoutSwitcherMenu';

export const LayoutSwitcher: FC<IOuter> = ({
  layout,
  layouts = [Layout.Gallery, Layout.List],
  onLayoutChange,
  className,
  tabName = undefined,
}) => {
  const { trackLayoutClick } = useTrackLayoutChange(tabName);

  const CurrentIcon = LayoutSwitcherIcons[layout];
  const trackLayoutChangeClick = useCallback(
    () => trackLayoutClick(LayoutChangeClickOrigin.TopRight),
    [trackLayoutClick],
  );

  const popoverContent = ({ closeMenu }) => (
    <LayoutSwitcherMenu
      layout={layout}
      onLayoutChange={memoizedOver(onLayoutChange, closeMenu)}
      layouts={layouts}
      tabName={tabName}
    />
  );

  return (
    <ToggleButtonWithPopover
      tooltipContent={<FormattedMessage id="layout-switcher.hint" />}
      popoverContent={popoverContent}
      onClick={trackLayoutChangeClick}
      className={className}
      dataHook="layout-switcher-button"
    >
      <CurrentIcon />
    </ToggleButtonWithPopover>
  );
};
